<template>
  <div class="page page-reports container is-fluid">
    <div class="container container-inner">
      <div class="columns is-flex is-gapless is-multiline">

        <!-- <div class="column content is-hidden-tablet" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true">
          <img src="../assets/image-07.jpg" class="img-responsive" />
        </div> -->

        <div class="column content content-main is-right">
          <div class="title" v-if="dataReports">
            {{ dataReports.title }}
          </div>
          <markdown v-if="dataReports && dataReports.content" :source="dataReports.content" />
          <div class="columns is-flex is-multiline has-text-centered">
            <div class="column" data-aos="fade-up" data-aos-once="true" v-if="dataExisting">
              <div class="box color-gray-lighter-bg" style="min-height:200px;">
                <div class="subtitle font-bold" style="font-weight:bold;">
                  {{ dataExisting.title }}
                </div>
                <a :href="dataExisting.link" target="_blank" class="button">{{ dataExisting.content }}</a>
              </div>
            </div>
            <div class="column" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="dataRegister">
              <div class="box color-gray-lighter-bg" style="min-height:200px;">
                <div class="subtitle font-bold" style="font-weight:bold;">
                  {{ dataRegister.title }}
                </div>
                <a :href="dataRegister.link" target="_blank" class="button">{{ dataRegister.content }}</a>
                <br />
                <a v-if="dataRegisterHow" :href="dataRegisterHow.link" target="_blank" style="font-size:0.9em;display:block;margin-top:10px;">{{ dataRegisterHow.content }}</a>
              </div>
            </div>
            <div class="column" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="dataSurvey">
              <div class="box color-gray-lighter-bg" style="min-height:200px;">
                <div class="subtitle font-bold" style="font-weight:bold;">
                  {{ dataSurvey.title }}
                </div>
                <a :href="dataSurvey.link" class="button">{{ dataSurvey.content }}</a>
                <!-- <br />
                <a v-if="dataSurvey" :href="dataSurvey.link" target="_blank" style="font-size:0.9em;display:block;margin-top:10px;">{{ dataSurvey.content }}</a> -->
              </div>
            </div>
            <div class="column" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="dataRegister">
              <div class="box color-gray-lighter-bg" style="min-height:200px;opacity:0.01;">
                <a href="#" class="button" style="pointer-events: none;">&lt;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&gt;</a>
                <br />
                <!-- <div class="subtitle font-bold" style="font-weight:bold;">
                  {{ dataRegister.title }}
                </div>
                <a :href="dataRegister.link" target="_blank" class="button">{{ dataRegister.content }}</a>
                <br />
                <a v-if="dataRegisterHow" :href="dataRegisterHow.link" target="_blank" style="font-size:0.9em;display:block;margin-top:10px;">{{ dataRegisterHow.content }}</a> -->
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="column content" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true">
          <img src="../assets/image-07.jpg" class="img-responsive is-hidden-mobile" />
          <div class="box color-gray-lighter-bg" v-if="false">
            <div class="text">
              For those in need of a Spanish speaking representative we have an associate available for you. Para aquellos que necesiten un representante que hable español tenemos un representante  disponible para asistirlo.
            </div>
          </div>
        </div>

        <div class="column content is-hidden-tablet" style="margin-bottom:0;" v-if="false">
          <div class="box color-gray-lighter-bg">
            <div class="subtitle" style="margin-bottom:0.8em;">
              Collection and Probation Services
            </div>
            <div class="text">
              We provide range of services. Click <a href="/services">here</a> for our list of services.
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'

import Site from '@/apis/Site'

export default {
  name: 'page-reports',
  components: {
    Markdown
  },
  data () {
    return {
      isDesktop: true,
      dataReports: undefined,
      dataExisting: undefined,
      dataRegister: undefined,
      dataRegisterHow: undefined,
      dataSurvey: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.getDataReports()
    this.getDataExisting()
    this.getDataRegister()
    this.getDataRegisterHow()
    this.getDataSurvey()
  },
  methods: {
    async getDataReports () {
      try {
        let data
        // dataReports
        this.dataReports = undefined
        data = await Site.aboutNamed('reports')
        if (data && data[0]) {
          data = data[0]
          this.dataReports = data
        }
      } catch (error) {
        console.log('faq error', error)
      }
    },

    async getDataExisting () {
      try {
        let data
        // dataExisting
        this.dataExisting = undefined
        data = await Site.hotlinkNameLike('reference-reports-existing')
        if (data && data[0]) {
          data = data[0]
          this.dataExisting = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getDataRegister () {
      try {
        let data
        // dataRegister
        this.dataRegister = undefined
        data = await Site.hotlinkNameLike('reference-reports-register')
        if (data && data[0]) {
          data = data[0]
          this.dataRegister = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getDataRegisterHow () {
      try {
        let data
        // dataRegisterHow
        this.dataRegisterHow = undefined
        data = await Site.hotlinkNameLike('reference-reports-register-how')
        if (data && data[0]) {
          data = data[0]
          this.dataRegisterHow = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getDataSurvey () {
      try {
        let data
        // dataSurvey
        this.dataSurvey = undefined
        data = await Site.hotlinkNameLike('reference-reports-survey')
        if (data && data[0]) {
          data = data[0]
          this.dataSurvey = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/page.scss";

.page-reports {
  .content {
    ul.list {
      li {
        margin-top: 30px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// reports.vue?4e44ea7b